import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormErrors} from '../common';
import UserClassroomAdditionForm from './UserClassroomAdditionForm';
import {addExistingUserToClassrooms} from 'api/classrooms';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';

class UserClassroomAddition extends React.Component {
  static propTypes = {
    schoolId: PropTypes.number,
    onSubmitSuccess: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(data) {
    const {userId, formatErrors, addFlashMessage, onSubmitSuccess} = this.props;
    return addExistingUserToClassrooms({
      classroomIds: data.classrooms.map((classroom) => classroom.id),
      userId,
    })
      .then(() => {
        addFlashMessage('User has been successfully added to the classroom(s)!', 'success');
        onSubmitSuccess();
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors} = this.state;
    const {schoolId} = this.props;
    return (
      <div>
        <FormErrors errors={errors} />
        <UserClassroomAdditionForm schoolId={schoolId} onSubmit={this.handleFormSubmit} />
      </div>
    );
  }
}

export default connect(null, {
  formatErrors,
  addFlashMessage,
})(UserClassroomAddition);
